import { getTurnstileToken } from './turnstile';

// Where form submissions are delivered / the fallback mailto target.
export const OFFICE_EMAIL = 'info@proveninfosec.com';

// Forms POST to the site's own mail API (server/index.js), which sends the
// email server-side over SMTP. One shared endpoint for every form — the
// `source` label is what tells the recipient which form was used.
export const buildMailtoLink = (subject, bodyLines) => {
  const body = bodyLines.filter((line) => line !== undefined && line !== null).join('\n');
  return `mailto:${OFFICE_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};

// Send a submission through the server mail API.
// `source`  — human label for the originating form (drives the email subject).
// `fields`  — flat object of label -> value shown in the email body.
// `replyTo` — the enquirer's email, so replies go straight back to them.
// Resolves true on success; throws on failure so the caller can surface it.
// Region is resolved from the host/stored preference so UK submissions can be
// delivered to the UK inbox and India/others to the .com inbox.
const activeRegion = () => {
  try {
    const host = (window.location.hostname || '').toLowerCase();
    if (host.endsWith('.co.uk')) return 'uk';
    return window.localStorage.getItem('region') || 'in';
  } catch (e) {
    return 'in';
  }
};

export const sendSubmission = async ({ source, fields, replyTo }) => {
  const turnstileToken = await getTurnstileToken();
  const res = await fetch('/api/contact', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ source, fields, replyTo, region: activeRegion(), turnstileToken }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.ok) {
    throw new Error(data.error || 'Submission failed');
  }
  return true;
};
